var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnelVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 4C1.3078 4 1 4.30281 1 4.67634V6.02903H12V4.67634C12 4.30281 11.6922 4 11.3125 4H1.6875ZM11.8503 7.38172H1.14971C1.22832 7.53359 1.33624 7.67115 1.46956 7.78591L5.125 10.9325V15L7.875 13.6473V10.9325L11.5304 7.78591C11.6638 7.67115 11.7717 7.53359 11.8503 7.38172ZM12.6875 10C12.3078 10 12 10.3028 12 10.6763V12.029H23V10.6763C23 10.3028 22.6922 10 22.3125 10H12.6875ZM22.8503 13.3817H12.1497C12.2283 13.5336 12.3362 13.6711 12.4696 13.7859L16.125 16.9325V21L18.875 19.6473V16.9325L22.5304 13.7859C22.6638 13.6711 22.7717 13.5336 22.8503 13.3817Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelVertical);
export default __webpack_public_path__ + "static/media/FunnelVertical.0fe8866b.svg";
export { ForwardRef as ReactComponent };